<div class="card bg-dark-lighter text-white">
  <div class="card-header ">
    <p>Categories</p>
    <div class="d-flex">
      <p-dropdown
        [options]="categories"
        class="rox-selector"
        name="selectedCategory"
        optionLabel="label"
        [(ngModel)]="selectedCategory"
        (onChange)="onSelectTypeChange()"
      ></p-dropdown>
      <div class="d-flex search-box ms-3">
        <input
          name="keyword"
          type="text"
          placeholder="Search"
          [(ngModel)]="condition.keyword"
          (keyup.enter)="onSearch()"
        >
        <div class="input-overlay"></div>
        <button mat-icon-button class="search-btn btn-main" mat-ripple (click)="onSearch()">
          <i class="fa fa-search"></i>
        </button>
      </div>
      <button class="btn btn-primary ms-auto" matTooltip="Export Data" matTooltipPosition="left" (click)="exportAllByClient()" create-permission>
        <i class="fa fa-download"></i>
      </button>
      <button class="btn btn-main ms-2" matTooltip="Refresh Data" matTooltipPosition="left" (click)="refreshPage()">
        <i class="fa fa-refresh"></i>
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark" id="tblCustomer">
            <thead>
              <tr>
                <th class="sortable mw-100" (click)="sortBy('id')">
                  MT5 ID
                  <i class="fa fa-{{
                      condition.orderBy === 'id'
                        ? sort.id === 'asc'
                          ? 'sort-asc'
                          : 'sort-desc'
                        : 'sort'
                    }}"
                  ></i>
                </th>
                <th class="text-center">MT5 User Type</th>
                <th class="text-center" (click)="sortBy('first_name')">
                  Username
                  <i class="fa fa-{{
                      condition.orderBy === 'first_name'
                        ? sort.first_name === 'asc'
                          ? 'sort-asc'
                          : 'sort-desc'
                        : 'sort'
                    }}"
                  ></i>
                </th>
                <th class="text-center">Username (JP)</th>
                <th class="text-center" (click)="sortBy('email')">
                  Email
                  <i class="fa fa-{{
                      condition.orderBy === 'email'
                        ? sort.email === 'asc'
                          ? 'sort-asc'
                          : 'sort-desc'
                        : 'sort'
                    }}"
                  ></i>
                </th>

                <th
                  class="text-center font-bold"
                  *ngIf="permission.allowCreating"
                >
                  MT5 account(s)
                </th>
                <th class="mw-150 active-select-box text-center" role="button">
                  KYC
                  <select
                    [(ngModel)]="condition.kycCode"
                    (change)="getListByKycStatus()"
                  >
                    <option value="">All</option>
                    <option
                      *ngFor="let kyc of listKYCStatus; let i = index"
                      value="{{ kyc[0] }}"
                    >
                      {{ kyc[1] }}
                    </option>
                  </select>
                </th>
                <th class="active-select-box text-center" style="width: fit-content;">
                  <label class="me-2">Activated</label>
                  <select id="activation-select" [(ngModel)]="activationStatus" (ngModelChange)="onActivationChange($event)">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </th>
                <th class="text-center" (click)="sortBy('active')">
                  Status
                  <i class="fa fa-{{
                      condition.orderBy === 'active'
                        ? sort.active === 'asc'
                          ? 'sort-asc'
                          : 'sort-desc'
                        : 'sort'
                    }}"
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let customer of customers
                    | paginate
                      : {
                          itemsPerPage: pageInfo.pageSize,
                          currentPage: pageInfo.pageIndex,
                          totalItems: pageInfo.totalRecord
                        };
                  let i = index
                "
              >
                <td class="{{(!customer.mt5Account || customer.mt5Account?.toString() === '') ? 'text-center' : ''}}">{{ (!customer.mt5Account || customer.mt5Account?.toString() === "") ? '- -' : customer.mt5Account}}</td>
                <td class="text-center">{{ userType[customer.userType] }}</td>
                <td class="text-center">{{ customer.getUsername() }}</td>
                <td class="text-center">{{ customer.getUsernameJP() }}</td>
                <td>
                  <span class="">{{ customer.email }}</span>
                </td>

                <td class="text-center cursor-pointer">
                  <span>{{customer.total_account}}</span>
                  <a
                    class="view-account-detail"
                    matTooltip="View Accounts"
                    matTooltipPosition="above"
                    routerLink="detail"
                    [queryParams]="{user_id: customer.id, email: customer.email, username: customer.getUsername()}"
                  >
                     <i class="fa fa-eye" style="font-size: 20px"></i>
                  </a>
                </td>
                <td class="pos-relative text-center">
                  <div class="box-inner" [innerHtml]="customer.getKYC()"></div>
                </td>
                <td class="text-center">
                  <span class="{{customer.verifiedEmail == 0 ? 'text-grey' : 'text-blue'}}">
                    {{ customer.verifiedEmail == 0 ? 'No' : 'Yes' }}
                  </span>
                </td>
                <td class="account-status un-active">
                  <ng-container *ngIf="customer.active === 1; else unactive">
                    <div
                      class="account-status active"
                      (click)="openConfirmInvalidateDialog(customer)"
                      matTooltip="Disable Account"
                      matTooltipPosition="left"
                      mat-ripple
                    >Active
                      <i class="fa fa-lock text-white" style="font-size: 20px" aria-hidden="true"></i>
                    </div>
                  </ng-container>
                  <ng-template #unactive>
                    Inactive
                  </ng-template>
                </td>


              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-15">
          <div class="col">
            <div class="pagination-wrapper">
              <pagination-controls
                (pageChange)="onPageChange($event)"
                autoHide="true"
                responsive="true"
                previousLabel="Prev"
                nextLabel="Next"
              >
              </pagination-controls>
            </div>
            <div class="ml-5" *ngIf="pageInfo.totalRecord > pageInfo.pageSize">
              <span>Page</span>
              <input
                class="ml-2"
                type="number"
                name="pageIndex"
                [(ngModel)]="pageInfo.pageManual"
                (keyup)="onKeyupPage($event)"
              />
              <button
                class="btn btn-primary ml-2"
                style="padding: 2px 0.75rem"
                (click)="onPageChange(pageInfo.pageManual)"
              >
                Go
              </button>
            </div>
          </div>
          <div class="col-auto">
            <span class="data-info "
            >Found: {{ pageInfo.totalRecord }}
              {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<fx-bonus-code #bonusCode></fx-bonus-code>

<ng-template #confirmInvalidate>
  <div class="dialog-box">
    <div class="dialog-header">Are you sure to disable this account</div>
    <div class="d-flex justify-content-center mt-3">
      <button class="btn-outline-do" mat-button color="warn" (click)="onInvalidate()">Disable</button>
      <button class="btn-outline-cancel ms-2" mat-button [mat-dialog-close]="true" cdkFocusInitial cdkTrapFocus>Cancel</button>
    </div>
  </div>
</ng-template>
